// @flow

import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import type { PollType, RootState, RoleId } from '../../types'

import { iconForType } from '../Icons'
import { urlForNewPollWherePollTypeId } from '../../urls'
import { selectCurrentUser } from '../../stores/currentUser'
import { selectPollTypes } from '../../stores/pollTypesStore'

import ColorButton from '../Controls/ColorButton'
import ClickTooltip from '../Controls/ClickTooltip'

const SLIDER = 'slider'
const RANKING = 'ranking'
const ONE_AXIS = 'one-axis'

const SliderIcon = iconForType(SLIDER)
const SpeedometerIcon = iconForType(ONE_AXIS)
const MultipleChoiceIcon = iconForType(RANKING)

type Props = {
  pollTypes: Array<PollType>,
  user: {
    id: string,
    name: string,
    email: string,
    customer?: Object,
    customerId: string,
    roleIds: Array<RoleId>,
  },
}

type State = {
  selected: boolean,
}

class CreatePoll extends React.Component<Props, State> {
  state = {
    selected: false,
  }

  render() {
    const toggleSelected = () =>
      this.setState({ selected: !this.state.selected })

    const renderIcons = () => {
      return (
        <div className="flex" onClick={toggleSelected}>
          <Link
            key={ONE_AXIS}
            to={urlForNewPollWherePollTypeId(ONE_AXIS)}
            className="link-create-speedometer link mh2"
            style={{ color: 'inherit' }}
          >
            <div className="flex flex-column justify-center items-center hover-op-brand">
              <SpeedometerIcon className="db h2 w2"></SpeedometerIcon>
              Speedometer
            </div>
          </Link>

          <Link
            key={RANKING}
            to={urlForNewPollWherePollTypeId(RANKING)}
            className="link-create-ranking link mh2"
            style={{ color: 'inherit' }}
          >
            <div className="flex flex-column justify-center items-center hover-op-brand">
              <MultipleChoiceIcon className="db h2 w2"></MultipleChoiceIcon>
              Multiple Choice
            </div>
          </Link>

          <Link
            key={SLIDER}
            to={urlForNewPollWherePollTypeId(SLIDER)}
            className="link mh2"
            style={{ color: 'inherit' }}
          >
            <div className="flex flex-column justify-center items-center hover-op-brand">
              <SliderIcon className="db h2 w2"></SliderIcon>
              Slider
            </div>
          </Link>
        </div>
      )
    }

    return (
      <div className="relative">
        <ClickTooltip
          colorClass="op-con-dark"
          arrowClass="white"
          backgroundClass="bg-white"
          tip={renderIcons()}
        >
          <ColorButton
            borderClass="b--op-brand"
            onClick={() => toggleSelected()}
            className={`${
              this.state.selected
                ? 'button-create-poll bg-op-brand'
                : 'button-create-poll'
            }`}
            colorClass={`${this.state.selected ? 'white' : 'op-brand'}`}
          >
            {' '}
            Create Poll
          </ColorButton>
        </ClickTooltip>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  user: selectCurrentUser(state),
  pollTypes: selectPollTypes(state),
})

export default connect(mapStateToProps)(CreatePoll)



// WEBPACK FOOTER //
// ./src/components/MainNavigation/CreatePoll.js